import type { Movie } from '@/types/content';

export const movies: Movie[] = [
  {
    id: 1,
    title: '星海远征',
    type: '电影',
    year: 2024,
    region: '中国大陆',
    genres: ['科幻', '冒险'],
    director: '陈立川',
    actors: ['周昱', '林知夏', '赵铭'],
    duration: '138分钟',
    rating: 8.7,
    heat: 9860,
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20artwork%20of%20a%20sci-fi%20space%20adventure%2C%20lone%20astronaut%20silhouette%20against%20a%20glowing%20nebula%2C%20deep%20navy%20and%20teal%20tones%2C%20dramatic%20rim%20lighting%2C%20highly%20detailed%20digital%20illustration%2C%20portrait%20composition&width=400&height=600&seq=movie-1&orientation=portrait',
    summary:
      '一支孤军远征队穿越虫洞寻找人类新家园，在星海深处直面未知文明的凝视，也直面彼此心底最深的恐惧。',
  },
  {
    id: 2,
    title: '长夜将至',
    type: '电视剧',
    year: 2024,
    region: '中国大陆',
    genres: ['悬疑', '犯罪'],
    director: '苏晚',
    actors: ['秦川', '顾南舟', '白露'],
    duration: '全24集',
    rating: 9.1,
    heat: 9820,
    cover:
      'https://readdy.ai/api/search-image?query=Noir%20crime%20thriller%20poster%20art%2C%20rainy%20city%20alley%20at%20night%20with%20a%20solitary%20figure%20under%20a%20streetlight%2C%20moody%20deep%20blue%20and%20amber%20contrast%2C%20film%20grain%20texture%2C%20cinematic%20portrait%20composition&width=400&height=600&seq=movie-2&orientation=portrait',
    summary:
      '一桩尘封十年的旧案重启调查，小镇上每个人的秘密都像夜色一样漫长，真相比想象中更接近身边人。',
  },
  {
    id: 3,
    title: '风起长安',
    type: '电视剧',
    year: 2023,
    region: '中国大陆',
    genres: ['古装', '历史'],
    director: '陆昭',
    actors: ['沈砚', '温以宁', '裴骁'],
    duration: '全40集',
    rating: 8.9,
    heat: 9710,
    cover:
      'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20historical%20drama%20poster%2C%20elegant%20figure%20in%20flowing%20hanfu%20robe%20standing%20before%20grand%20palace%20walls%2C%20warm%20golden%20lanternlight%2C%20ink%20wash%20texture%2C%20refined%20portrait%20composition&width=400&height=600&seq=movie-3&orientation=portrait',
    summary:
      '盛世长安之下暗流涌动，一位寒门书生卷入朝堂与江湖的双重博弈，以赤诚之心守护心中的道义。',
  },
  {
    id: 4,
    title: '深海回声',
    type: '电影',
    year: 2023,
    region: '美国',
    genres: ['惊悚', '剧情'],
    director: 'Edward Nolan',
    actors: ['Grace Holloway', 'Marcus Reed'],
    duration: '124分钟',
    rating: 8.3,
    heat: 9540,
    cover:
      'https://readdy.ai/api/search-image?query=Psychological%20thriller%20movie%20poster%2C%20submerged%20figure%20deep%20underwater%20with%20caustic%20light%20rays%2C%20cold%20desaturated%20teal%20palette%2C%20eerie%20atmosphere%2C%20cinematic%20portrait%20composition%2C%20high%20detail&width=400&height=600&seq=movie-4&orientation=portrait',
    summary:
      '一位海洋声学研究员在深海勘测中捕捉到无法解释的回声，越靠近真相，她越难分辨现实与记忆的边界。',
  },
  {
    id: 5,
    title: '时光代理人',
    type: '电视剧',
    year: 2024,
    region: '中国大陆',
    genres: ['奇幻', '爱情'],
    director: '许安然',
    actors: ['江野', '程星禾'],
    duration: '全28集',
    rating: 8.5,
    heat: 9430,
    cover:
      'https://readdy.ai/api/search-image?query=Fantasy%20romance%20drama%20poster%2C%20two%20silhouettes%20reaching%20toward%20each%20other%20across%20a%20glowing%20clock%20portal%2C%20warm%20coral%20and%20soft%20violet%20light%2C%20dreamy%20bokeh%2C%20portrait%20composition&width=400&height=600&seq=movie-5&orientation=portrait',
    summary:
      '一家可以代人回到过去的奇妙事务所，两个擅长修补遗憾的年轻人，却始终无法修补属于彼此的那段时光。',
  },
  {
    id: 6,
    title: '无声之城',
    type: '电影',
    year: 2024,
    region: '韩国',
    genres: ['犯罪', '悬疑'],
    director: '朴正勋',
    actors: ['李河俊', '金秀雅'],
    duration: '131分钟',
    rating: 8.6,
    heat: 9380,
    cover:
      'https://readdy.ai/api/search-image?query=Korean%20crime%20noir%20poster%2C%20empty%20city%20street%20at%20dawn%20with%20distant%20figure%20in%20long%20coat%2C%20cold%20grey%20and%20crimson%20accent%2C%20moody%20fog%2C%20cinematic%20portrait%20composition&width=400&height=600&seq=movie-6&orientation=portrait',
    summary:
      '整座城市在一夜之间失去声音，唯一能听见的警探必须在自己失聪前，找出制造这场沉默的凶手。',
  },
  {
    id: 7,
    title: '雪山孤影',
    type: '电影',
    year: 2022,
    region: '挪威',
    genres: ['冒险', '剧情'],
    director: 'Lars Berg',
    actors: ['Ingrid Solberg', 'Nils Aas'],
    duration: '118分钟',
    rating: 8.1,
    heat: 8120,
    cover:
      'https://readdy.ai/api/search-image?query=Survival%20adventure%20poster%2C%20solitary%20climber%20on%20a%20vast%20snowy%20mountain%20ridge%2C%20pale%20blue%20and%20white%20snow%20tones%2C%20dramatic%20scale%2C%20cinematic%20portrait%20composition%2C%20high%20detail&width=400&height=600&seq=movie-7&orientation=portrait',
    summary:
      '一场雪崩让登山者与队伍失联，独自在极寒雪原求生的七天里，支撑他的只剩一段未说完的告别。',
  },
  {
    id: 8,
    title: '都市浮光',
    type: '电视剧',
    year: 2023,
    region: '中国大陆',
    genres: ['都市', '情感'],
    director: '郑亦欢',
    actors: ['陆沉', '苏梨', '何嘉'],
    duration: '全36集',
    rating: 7.9,
    heat: 8610,
    cover:
      'https://readdy.ai/api/search-image?query=Modern%20urban%20drama%20poster%2C%20young%20professionals%20walking%20through%20a%20neon%20city%20at%20dusk%2C%20warm%20orange%20and%20slate%20blue%20tones%2C%20rain%20gloss%20reflections%2C%20portrait%20composition&width=400&height=600&seq=movie-8&orientation=portrait',
    summary:
      '三个在都市打拼的年轻人，被同一场项目危机捆在一起，在浮光掠影的城市里重新定义友情与理想。',
  },
  {
    id: 9,
    title: '机甲纪元',
    type: '电影',
    year: 2025,
    region: '日本',
    genres: ['动画', '科幻'],
    director: '新田凉介',
    actors: ['配音·佐藤悠', '配音·小林凛'],
    duration: '142分钟',
    rating: 8.8,
    heat: 9760,
    cover:
      'https://readdy.ai/api/search-image?query=Japanese%20mecha%20anime%20movie%20poster%2C%20giant%20robot%20silhouette%20against%20a%20burning%20sunset%20sky%2C%20vivid%20orange%20and%20steel%20blue%20tones%2C%20dynamic%20action%20lines%2C%20portrait%20composition&width=400&height=600&seq=movie-9&orientation=portrait',
    summary:
      '少年驾驶员与一台上古机甲在废墟都市中并肩作战，揭开一段被埋藏在钢铁里的族人与星球的秘密。',
  },
  {
    id: 10,
    title: '雨林秘境',
    type: '纪录片',
    year: 2023,
    region: '英国',
    genres: ['纪录', '自然'],
    director: 'David Attenly',
    actors: ['旁白·Anna Voss'],
    duration: '全6集',
    rating: 9.2,
    heat: 8430,
    cover:
      'https://readdy.ai/api/search-image?query=Nature%20documentary%20poster%2C%20lush%20emerald%20rainforest%20canopy%20with%20rare%20colorful%20birds%2C%20sunbeams%20through%20mist%2C%20rich%20green%20and%20amber%20tones%2C%20portrait%20composition&width=400&height=600&seq=movie-10&orientation=portrait',
    summary:
      '深入地球上最后一片未被完全探明的热带雨林，用四年时间记录那些从未被镜头捕捉过的生命奇迹。',
  },
  {
    id: 11,
    title: '律师风云',
    type: '电视剧',
    year: 2022,
    region: '美国',
    genres: ['剧情', '律政'],
    director: 'Robert Klein',
    actors: ['Diana Moore', 'James Carter'],
    duration: '全22集',
    rating: 8.4,
    heat: 8210,
    cover:
      'https://readdy.ai/api/search-image?query=Legal%20drama%20poster%2C%20confident%20lawyer%20silhouette%20before%20tall%20courthouse%20windows%2C%20muted%20charcoal%20and%20deep%20gold%20tones%2C%20formal%20elegant%20composition%2C%20portrait%20orientation&width=400&height=600&seq=movie-11&orientation=portrait',
    summary:
      '一位从不败诉的顶尖辩护律师，接下了一桩连自己都怀疑的案子，在法庭内外重新审视正义的代价。',
  },
  {
    id: 12,
    title: '归途列车',
    type: '电影',
    year: 2021,
    region: '中国大陆',
    genres: ['剧情', '家庭'],
    director: '田野',
    actors: ['贺明', '刘桂芳'],
    duration: '112分钟',
    rating: 8.2,
    heat: 7640,
    cover:
      'https://readdy.ai/api/search-image?query=Family%20drama%20movie%20poster%2C%20warmly%20lit%20train%20window%20with%20a%20father%20and%20child%20looking%20outside%2C%20nostalgic%20amber%20and%20soft%20brown%20tones%2C%20tender%20mood%2C%20portrait%20composition&width=400&height=600&seq=movie-12&orientation=portrait',
    summary:
      '阔别家乡二十年的父亲带着女儿踏上春运归途，一趟漫长列车，驶向那些来不及说出口的原谅。',
  },
  {
    id: 13,
    title: '量子迷宫',
    type: '电影',
    year: 2025,
    region: '美国',
    genres: ['科幻', '悬疑'],
    director: 'Sofia Reyes',
    actors: ['Ethan Park', 'Nora Blake'],
    duration: '136分钟',
    rating: 8.5,
    heat: 9620,
    cover:
      'https://readdy.ai/api/search-image?query=Mind-bending%20sci-fi%20poster%2C%20figure%20splitting%20into%20mirrored%20reflections%20inside%20a%20glowing%20geometric%20maze%2C%20electric%20cyan%20and%20deep%20indigo%20tones%2C%20portrait%20composition&width=400&height=600&seq=movie-13&orientation=portrait',
    summary:
      '一位物理学家发现自己每天醒来都在同一天的不同版本里，而找出迷宫出口的唯一线索，藏在她的记忆深处。',
  },
  {
    id: 14,
    title: '胡同烟火',
    type: '电视剧',
    year: 2024,
    region: '中国大陆',
    genres: ['喜剧', '生活'],
    director: '马小满',
    actors: ['王大山', '刘欣然', '郭宝'],
    duration: '全30集',
    rating: 8.0,
    heat: 8340,
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20slice-of-life%20comedy%20poster%2C%20cheerful%20old%20hutong%20alley%20with%20steaming%20food%20stalls%20and%20lanterns%2C%20cozy%20amber%20and%20brick%20red%20tones%2C%20portrait%20composition&width=400&height=600&seq=movie-14&orientation=portrait',
    summary:
      '老北京胡同里的一间小面馆，见证着街坊邻居的鸡飞狗跳与人间温情，一碗面里藏着整个时代的烟火气。',
  },
  {
    id: 15,
    title: '暗河',
    type: '电影',
    year: 2023,
    region: '中国大陆',
    genres: ['悬疑', '惊悚'],
    director: '程野',
    actors: ['段骁', '许岚'],
    duration: '120分钟',
    rating: 8.3,
    heat: 8760,
    cover:
      'https://readdy.ai/api/search-image?query=Suspense%20thriller%20poster%2C%20dark%20underground%20river%20tunnel%20with%20a%20flashlight%20beam%2C%20cold%20black%20and%20emerald%20green%20tones%2C%20claustrophobic%20tension%2C%20portrait%20composition&width=400&height=600&seq=movie-15&orientation=portrait',
    summary:
      '一具无名尸体牵出地下暗河般的利益链，执着的老刑警顺着水流逆流而上，摸到了城市光鲜之下的暗面。',
  },
  {
    id: 16,
    title: '北极星',
    type: '电视剧',
    year: 2025,
    region: '英国',
    genres: ['科幻', '剧情'],
    director: 'Oliver Grant',
    actors: ['Sophie Lane', 'Liam Doyle'],
    duration: '全10集',
    rating: 8.9,
    heat: 9240,
    cover:
      'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20series%20poster%2C%20lone%20space%20station%20orbiting%20a%20bright%20star%20above%20a%20frozen%20planet%2C%20cold%20silver%20blue%20and%20pale%20gold%20tones%2C%20portrait%20composition&width=400&height=600&seq=movie-16&orientation=portrait',
    summary:
      '前往北极星系的殖民飞船在途中失去联系，留守地球的指挥官必须在谎言与真相之间，为船员做出抉择。',
  },
  {
    id: 17,
    title: '赤焰行动',
    type: '电影',
    year: 2024,
    region: '中国香港',
    genres: ['动作', '警匪'],
    director: '陈国栋',
    actors: ['黎劲', '何俊贤', '周嘉莉'],
    duration: '126分钟',
    rating: 8.0,
    heat: 9010,
    cover:
      'https://readdy.ai/api/search-image?query=Action%20cop%20thriller%20poster%2C%20two%20figures%20in%20a%20standoff%20amid%20neon%20city%20streets%20and%20sparks%2C%20fiery%20orange%20and%20deep%20navy%20tones%2C%20high-contrast%20portrait%20composition&width=400&height=600&seq=movie-17&orientation=portrait',
    summary:
      '一队卧底警察与跨国犯罪集团在都市中心展开殊死较量，当身份暴露，他们只剩一次逆转局势的机会。',
  },
  {
    id: 18,
    title: '春日邮局',
    type: '电视剧',
    year: 2023,
    region: '日本',
    genres: ['治愈', '爱情'],
    director: '小林和树',
    actors: ['山田奏', '铃木葵'],
    duration: '全12集',
    rating: 8.6,
    heat: 8590,
    cover:
      'https://readdy.ai/api/search-image?query=Healing%20romance%20drama%20poster%2C%20charming%20small%20town%20post%20office%20surrounded%20by%20cherry%20blossoms%2C%20soft%20pastel%20pink%20and%20warm%20cream%20tones%2C%20gentle%20sunlight%2C%20portrait%20composition&width=400&height=600&seq=movie-18&orientation=portrait',
    summary:
      '海边小镇的一间旧邮局里，代写书信的女孩与投递信件的邮差，用一封封手写信打捞起小镇人隐秘的心事。',
  },
];

export const genreOptions = [
  '科幻',
  '冒险',
  '悬疑',
  '犯罪',
  '古装',
  '历史',
  '惊悚',
  '剧情',
  '奇幻',
  '爱情',
  '动画',
  '纪录',
  '自然',
  '律政',
  '家庭',
  '喜剧',
  '生活',
  '动作',
  '警匪',
  '治愈',
  '都市',
  '情感',
];

export const yearOptions = [2025, 2024, 2023, 2022, 2021];

export const regionOptions = ['中国大陆', '中国香港', '美国', '英国', '韩国', '日本', '挪威'];